export class ClientfunctionModel {
  id: number;
  function: string;
  _isEditMode: boolean;
}
